import { Select, styled, TextareaAutosize } from "@mui/material";
import { exProps } from "utils/mui";

export const InputWrapper = styled('div', exProps("disabled"))<{ disabled?: boolean }>(({ theme, disabled }) => ({
  display: "flex",
  justifyContent: "space-between",
  height: 40,
  alignItems: "center",
  ...disabled && {
    opacity: 0.6
  }
}))

export const MultilneInputWrapper = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(0.5),
  display: "flex",
  flexDirection: "column"
}))

export const InputLabel = styled('label')(({ theme }) => ({
  fontWeight: 600,
  fontSize: 11
}))

export const InputComponent = styled('input', exProps("error"))<{ error: boolean }>(({ theme, error }) => ({
  flexBasis: 280,
  background: "#2C3748",
  borderRadius: 5,
  height: 28,
  color: "white",
  fontFamily: theme.typography.fontFamily,
  outline: "none",
  paddingLeft: theme.spacing(1.2),
  fontSize: 11,
  border: `1px solid transparent`,
  ...error && {
    borderColor: theme.palette.error.main
  },
  ":focus": {
    borderColor: theme.palette.primary.dark
  }
}))

export const TextareaWrapper = styled('div')(({ theme }) => ({
  border: `1px solid transparent`,
  borderRadius: 5,
  background: "#2C3748",
  padding: theme.spacing(0.9),
  paddingTop: theme.spacing(0.3),
  paddingBottom: theme.spacing(0),
  marginTop: theme.spacing(0.2),
  marginBottom: theme.spacing(1),
  ":focus-within": {
    borderColor: theme.palette.primary.dark
  }
}))

export const Textarea = styled(TextareaAutosize)(({ theme }) => ({
  background: "transparent",
  width: "100%",
  border: "none",
  height: 28,
  color: "white",
  fontFamily: theme.typography.fontFamily,
  outline: "none",
  fontSize: 11,
  resize: "none"
}))

export const SelectComponent = styled(Select)(({ theme }) => ({
  height: 28,
  backgroundColor: "#2C3748",
  flexBasis: 280,
  borderRadius: 5,
  "&>div": {
    paddingTop: 8,
    paddingBottom: 8,
  },

  "fieldset": {
    border: "none"
  }
}))